import { OnObject3dInit } from '@magicore/visualize-3d';
import { AmbientLight, Color, DirectionalLight, Light, Object3D } from 'three';
import type { Visualize3dObject } from '@magicore/visualize-3d';
import type { ActiconSceneLightComponent } from './scene-light';

// NOTE: Intensity 1 is pure white and will wash out anything - using max intensity is already plenty
const maxIntensity = 1;
const minIntensity = 0.8;

/**
 * Handler for the Acticon scene lighting system for the 3D model.
 *
 * This handler will add the provided lights to the scene.
 */
export class ActiconSceneLightComponentHandler implements OnObject3dInit {
  initialize(object3d: Object3D, v3dObject: Visualize3dObject, component: ActiconSceneLightComponent): void {
    if (!component.directions.length) {
      return;
    }

    // Create the color from the color representation string
    const color = new Color(component.color);

    // How much each light should be dimmed. The first light is the brightest and the last light is the dimmest.
    const intensityStep = (maxIntensity - minIntensity) / component.directions.length;

    // Create directional lights
    const lights: Light[] = component.directions.map((direction, i) => {
      // Scale the light intensity
      const intensity = maxIntensity - intensityStep * i;

      // Create light & set its position
      const light = new DirectionalLight(color, intensity);
      light.position.copy(direction);

      return light;
    });

    // Add ambient light to ensure all parts of the model are lit
    const ambientIntensity = 0.9;
    lights.push(new AmbientLight(color, ambientIntensity));

    // Add lights to the THREE.Object3D
    object3d.add(...lights);
  }
}
